import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Global/Icons/IconWithText';

const TrendingSearches = ({ results, linkClasses, icon, titleClasses }) => {
  const linkClass = `like-h5 link ${linkClasses}`;

  return (
    <div className="trending-searches m-t-2 d-flex align-items-center">
      {icon ? (
        <IconWithText name="trending-up" fill="green" size="m"><h2 className={titleClasses}>Trending searches:</h2></IconWithText>
      ) : (
        <h2 className={titleClasses}>Trending searches:</h2>
      )}

      <ul className="inline-list-new inline-list-new--xs m-l-1">
        {results && results.map(result => (
          <li key={result}><a href={`/search?term=${result}&spellcheckEnabled=false`} className={linkClass}>{result}</a></li>
        ))}
      </ul>
    </div>
  );
};

TrendingSearches.propTypes = {
  results: PropTypes.array,
  linkClasses: PropTypes.string,
  icon: PropTypes.bool,
  titleClasses: PropTypes.string,
};

export default TrendingSearches;



// WEBPACK FOOTER //
// ./library/app/components/Search/TrendingSearches.js